<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent v-loading="loadingConfirm">
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title">{{L.authentication}}</div>
      <div class="notice">{{L.weSend}}</div>
      <div class="phone">{{phone}}</div>
      <div class="inp-wrap">
        <el-input size="small" class="inp" v-model="verifyCode"></el-input>
        <div class="send-code" v-if="!openInterval" @click="sendCode" v-loading="loadingSend">{{L.sendVerifyCode}}</div>
        <div class="time-btn" v-if="openInterval">{{time}} s</div>
      </div>
      <div class="btn-wrap" @click="handleConfirm">{{L.confirm}}</div>
    </div>
  </div>
</template>

<script>
import {api_order_send_verify_code_LED,api_order_confirm_verify_code_LED,api_order_get_phone} from '@/api/api'
import {downFileGet} from '@/api/tool'
import { postAction } from '../api/tool'
import Vue from 'vue'

export default {
  name:'VerifyContractLED',
  props:['ledOrderNo'],
  data() {
    return {
      loadingSend:false,
      loadingConfirm:false,
      show:false,
      verifyCode:'',
      interval:null,
      openInterval:false,
      phone:'',
      time:60
    }
  },
  methods:{
    open(){
      this.show=true
      this.openInterval=false
      this.verifyCode=''
      this.getPhone()
    },
    getPhone(){
      this.loadingConfirm=true
      postAction(api_order_get_phone).then(res=>{
        this.loadingConfirm=false
        this.phone=res.phoneNumber
      }).catch(()=>{
        this.loadingConfirm=false
      })
    },
    close(){
      this.show=false
      clearInterval(this.interval)
      this.openInterval=false
    },
    /* 发验证码 */
    sendCode(){
      let params = {
        ledOrderNo:this.ledOrderNo
      }
      this.loadingSend=true
      postAction(api_order_send_verify_code_LED,params).then(()=>{
        this.$message.success('Send successfully')
        this.loadingSend=false
        this.time--
        this.openInterval=true
        this.interval=setInterval(()=>{
          if(this.time>1){
            this.time--
          }else{
            clearInterval(this.interval)
            this.time=60
            this.openInterval=false
          }
        },1000)
      }).catch(()=>{
        this.loadingSend=false
      })
    },
    handleConfirm(){
      if(!this.verifyCode){
        this.$message({
          message: 'Please enter the verification code',
          type: 'warning'
        })
        return
      }
      let params = {
        ledOrderNo:this.ledOrderNo,
        verifyCode:this.verifyCode
      }
      this.loadingConfirm=true
      postAction(api_order_confirm_verify_code_LED,params).then(res=>{
        this.loadingConfirm=false
        let url='/'+res.contractFileUrl.split(Vue.config.YUNPAN_URL)[1]
        this.$emit('finishContract')
        this.close()
        downFileGet(url).then(res=>{
          this.downloadFile(res,1)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding:40px;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title{
      font-size: 16px;
      font-weight: 600;
    }
    .notice{
      margin-top: 10px;
      margin-bottom: 6px;
    }
    .phone{
      color:@mainColor;
      font-size: 16px;
    }
    .inp-wrap{
      margin-top: 10px;
      display:flex;
      .inp{
        flex: 1;
      }
      .send-code{
        width:180px;
        color:@mainColor;
        border-radius: 4px;
        border:1px solid @mainColor;
        line-height: 32px;
        margin-left: 10px;
        text-align: center;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          background: @mainColor;
          color: #fff;
          &:extend(.transtion-time);
        }
      }
      .time-btn{
        width:180px;
        color:#fff;
        border-radius: 4px;
        border:1px solid @notClickBtn;
        line-height: 32px;
        margin-left: 10px;
        text-align: center;
        cursor:not-allowed;
        background-color: @notClickBtn;
      }
    }
    .btn-wrap{
      margin-top: 26px;
      text-align: center;
      width:100%;
      color:#fff;
      background-color: @mainColor;
      padding:8px 6px;
      box-sizing: border-box;
      border:1px solid @mainColor;
      border-radius: 2px;
      &:extend(.transtion-time);
      .icon-cart{
        margin-right: 6px;
      }
      &:hover{
        cursor: pointer;
        color:@mainColor;
        background-color: #fff;
        &:extend(.transtion-time);
      }
    }
  }
}

</style>